import { useGlobals } from 'hooks/useGlobals';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { useOpenSearchContext } from 'hooks/useOpenSearchContext';
import { ILastSearchedDriver, TLastSarchedDriversProps } from 'open-search/types';

const useLastSearchedDrivers = () => {
  const { getStorageData, setStorageData } = useLocalStorage();
  const {
    setIsProfileVisible,
    setTruckerId,
    setIsLastSearchedDriversVisible,
    setValueInputSearch,
    setIsTextFieldFocus,
    setIsLastSearchedDrivers,
  } = useOpenSearchContext();

  const globals = useGlobals();

  const getCompanyId = () => globals?.user?.data?.company?.id_hashed;

  const getUserId = () => globals?.user?.id_hashed;

  const getStorageKey = () => `userLastSearchedDrivers-${getCompanyId()}-${getUserId()}`;

  const setNewData = (updatedSearchedDrivres: ILastSearchedDriver[]) => {
    setStorageData(getStorageKey(), updatedSearchedDrivres);
  };

  const getIndexIfExists = (lastSearchedDrivers: ILastSearchedDriver[], newItem: ILastSearchedDriver) =>
    lastSearchedDrivers.findIndex((driver) => driver.id === newItem.id);

  const getLastSearchedDriversFromLocalStorage = (): ILastSearchedDriver[] => getStorageData(getStorageKey());

  const updateSearchedDrivers = (newSearchedDriver: ILastSearchedDriver) => {
    const lastSearchedDrivers = getLastSearchedDriversFromLocalStorage() || [];

    if (lastSearchedDrivers.length > 0) {
      const newItemIndex = getIndexIfExists(lastSearchedDrivers, newSearchedDriver);

      if (newItemIndex !== -1) {
        if (newItemIndex === 0) {
          return;
        }

        lastSearchedDrivers.splice(newItemIndex, 1);
        lastSearchedDrivers.unshift(newSearchedDriver);

        setNewData(lastSearchedDrivers);

        return;
      }

      if (lastSearchedDrivers.length <= 2) {
        lastSearchedDrivers.unshift(newSearchedDriver);

        setNewData(lastSearchedDrivers);

        return;
      }

      lastSearchedDrivers.pop();
      lastSearchedDrivers.unshift(newSearchedDriver);

      setNewData(lastSearchedDrivers);

      return;
    }
    setNewData([newSearchedDriver]);
  };

  const openProfile = (lastSearchedDriverData: ILastSearchedDriver) => {
    setTruckerId(lastSearchedDriverData.id);
    updateSearchedDrivers(lastSearchedDriverData);
    setIsProfileVisible(true);
    setIsLastSearchedDriversVisible(false);
    setValueInputSearch('');
    setIsTextFieldFocus(false);
    setIsLastSearchedDrivers(true);
  };

  const propsLastSearchedDrivers: TLastSarchedDriversProps = {
    lastSearchedDrivers: getLastSearchedDriversFromLocalStorage(),
    openProfile,
  };

  return { updateSearchedDrivers, propsLastSearchedDrivers };
};

export { useLastSearchedDrivers };
